import {
  User, MessageSquare, ArrowDownCircle, ArrowUpCircle,
  Gift, History, Users, ShieldCheck, Lock, Ticket, TicketPercent, ReceiptText, Link as LinkIcon,
} from 'lucide-react';

const accountItems = [
  { to: '/hesap/profil', icon: User, label: 'Profilim' },
  { to: '/hesap/guvenlik', icon: Lock, label: 'Güvenlik' },
  { to: '/hesap/mesajlar', icon: MessageSquare, label: 'Mesajlarım' },
  { to: '/hesap/para-yatir', icon: ArrowDownCircle, label: 'Para Yatır' },
  { to: '/hesap/para-cek', icon: ArrowUpCircle, label: 'Para Çek' },
  { to: '/hesap/islemler', icon: ReceiptText, label: 'Hesap Hareketleri' },
  { to: '/promosyonlar', icon: Gift, label: 'Bonuslarım' },
  { to: '/promosyon-kodu', icon: TicketPercent, label: 'Promosyon Kodu' },
  { to: '/hesap/kayip-bonusu', icon: Gift, label: 'Kayıp Bonusu' },
  { to: '/hesap/affiliate', icon: Users, label: 'Affiliate' },
  { to: '/hesap/oyun-gecmisi', icon: History, label: 'Oyun Geçmişi' },
  { to: '/hesap/bahis-kuponlari', icon: Ticket, label: 'Bahis Kuponlarım' },
];

const adminItem = {
  to: '/admin',
  icon: ShieldCheck,
  label: 'Yönetim Paneli',
  admin: true,
};

// Menüdeki "Bonuslarım" kampanya listesine değil hesap bölümündeki kendi
// sayfasına gider (`/hesap/bonuslarim`): oyuncunun çevrimi süren bonusu,
// freespin ve freebet hakları oradadır ve kartlar Bonuslar sayfasında
// kampanyaları ekranın altına itiyordu (pages/Promotions.jsx `MyRewards`).
// Menünün kendisi değil **hedefi** değişir: kampanyalara giden yol üst
// menüde ve Bonuslar sayfasının kendi adresinde durmaya devam eder.
const MENU_REDIRECT = { '/promosyonlar': '/hesap/bonuslarim' };

// Şemaya özel menü düzenlemeleri. Betrun'da "Kayıp Bonusu" menüde yoktur
// (sayfa adresle açılmaya devam eder, yalnızca kısayol düşer).
const THEME_MENU = {
  betrun: {
    hidden: new Set(['/hesap/kayip-bonusu']),
  },
};

// Promosyon Kodu bu listenin bir maddesidir ama rotası hesap bölümünün
// dışındadır (`/promosyon-kodu`, ziyaretçiye de açıktır); giriş yapmış üyeye
// hesap kabuğunun içinde çizilir (bkz. App.js `PromoCodeRoute`).

// ``sportsEnabled`` panelden spor kapatıldığında kupon sekmesini gizler;
// ayar yüklenmeden çağrıldığında sekme görünür kalır (varsayılan açıktır).
//
// ``adminVisible`` yönetim paneli ayrı bir alan adına kilitlendiğinde kısayolu
// düşürür: bağlantı bu adreste hiçbir şey açmaz (bkz. lib/adminDomain.js).
// CMS › Menüler › Profil Menüsü: panelden sıralanan / gizlenen / eklenen
// maddeler (settings.cms_menus.profile). İkon anahtarları backend'deki
// cms_admin.PROFILE_DEFAULTS ile aynıdır.
export const PROFILE_ICONS = {
  user: User, lock: Lock, message: MessageSquare, deposit: ArrowDownCircle, withdraw: ArrowUpCircle,
  receipt: ReceiptText, gift: Gift, 'ticket-percent': TicketPercent, users: Users, history: History,
  ticket: Ticket,
};
const currentLang = () => (typeof document !== 'undefined' && document.documentElement.lang
  ? document.documentElement.lang.slice(0, 2).toLowerCase() : 'tr');

export const cmsProfileItems = (menu) => {
  if (!Array.isArray(menu) || !menu.length) return null;
  const lang = currentLang();
  const byPath = Object.fromEntries(accountItems.map((item) => [item.to, item]));
  return menu.filter((item) => item && item.url && !(item.hide_langs || []).includes(lang)).map((item) => {
    const base = byPath[item.url];
    return {
      to: item.url, label: item.label || base?.label || item.url,
      icon: PROFILE_ICONS[item.icon] || base?.icon || LinkIcon,
      badge: item.badge || null, newTab: Boolean(item.new_tab), external: /^https?:/i.test(item.url),
    };
  });
};

export const getAccountMenuItems = (
  user, {
    sportsEnabled = true, adminVisible = true, themeId = '', cmsMenu = null,
  } = {},
) => {
  const themeMenu = THEME_MENU[themeId];
  const source = cmsProfileItems(cmsMenu) || accountItems;
  const visibleItems = source.filter(
    (item) => (
      (item.to !== '/hesap/affiliate' || user?.can_use_affiliate)
      && (item.to !== '/hesap/bahis-kuponlari' || sportsEnabled)
      && !themeMenu?.hidden?.has(item.to)
    ),
  ).map((item) => (
    MENU_REDIRECT[item.to] ? { ...item, to: MENU_REDIRECT[item.to] } : item
  ));
  return user?.is_admin && adminVisible
    ? [adminItem, ...visibleItems] : visibleItems;
};
